import React from "react";
import { styled } from "@mui/system";
import MUIListItemButton, {
  ListItemButtonProps,
} from "@mui/material/ListItemButton";

export const ListItemButton = styled(
  (props: ListItemButtonProps) => <MUIListItemButton {...props} />,
  {
    name: "ListItemButton",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({
  background: theme.palette.primary.surfaceDefault,
  "&.MuiListItemButton-root": {
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid " + theme.palette.primary.interactiveDefault,
      background: theme.palette.primary.surfaceDefault,
    },
  },
  "&.MuiListItemButton-root > .MuiSvgIcon-root": {
    color: theme.palette.primary.iconDefault,
    fontSize: 20,
  },
}));
